export const state = () => ({
  apiPreFix: '/api/sm',
  apiBookMark: 'manager/bookmark',
  apiBookMarkApply: 'manager/bookmark/apply',
  apiBookMarkCancel: 'manager/bookmark/cancel',
  bookmark: []
})

export const mutations = {
  getBookMark (state, data) {
    state.bookmark = data
  },
  setBookMark (state, data) {
    state.bookmark = data
  }
}

export const actions = {
  async getBookMark ({ commit, state }, {apiUrl, adminId}) {
    const uri = `${state.apiPreFix}/${apiUrl}/${adminId}`
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(uri)
      if (code === 'ok') {
        commit('getBookMark', result)
      } else {
        res.code = code
      }
    } catch (e) {
      res.code = e
    }
    return res
  },
  async setBookMark ({ commit, state }, {apiUrl, adminId, key}) {
    const uri = `${state.apiPreFix}/${apiUrl}/${adminId}`
    const res = {code: 'ok'}
    const setData = {
      bkmk: _.cloneDeep(state.bookmark.bkmk)
    }
    const index = setData.bkmk.indexOf(key)
    if (index === -1) {
      setData.bkmk.push(key)
    } else {
      setData.bkmk.splice(index, 1)
    }
    try {
      const {code, result} = await this.$axios.$put(uri, setData, {successAlert: false})
      if (code === 'ok') {
        commit('setBookMark', result)
        this.dispatch(`common/common/setIsChanged`, true)
        res.result = result
      } else {
        res.code = code
      }
    } catch (e) {
      res.code = e
    }
    return res
  }
}

export const getters = {}

export const strict = false
